import Recat, {useState, useEffect} from "react";

export function randomise() {
    const game_choices = [
    [
        // GAME 1 - EASY; COMPLETE IN 1 MOVE
            ["1","2","","4","5","3","7","8","9"], 
            ["N", "N", "Y", "N", "Y", "N", "N", "N", "Y"],
            ["1", "2", "3", "4", "5", "", "7", "8", "9"],
            "1,2,3,4,5,,7,8,9"
        ],
        // // GAME 2
        [
            ["3", "2", "9", "6", "1", "4", "", "7", "8"], 
            ["N", "N", "N", "Y", "N", "N", "N", "Y", "N"],
            ["1", "2", "3", "4", "", "6", "7", "8", "9"],
            "1,2,3,4,,6,7,8,9,"
        ],
        // GAME 3
        [
            ["8", "9", "5", "", "6", "4", "3", "1", "7"], 
            ["Y", "N", "N", "N", "Y", "N", "Y", "N", "N"],
            ["1", "", "3", "4", "5", "6", "7", "8", "9"],
            "1,,3,4,5,6,7,8,9"
        ],
        // GAME 4
        [
            ["9", "8", "1", "7", "", "2", "5", "6", "3"],
            ["N", "Y", "N", "Y", "N", "Y", "N", "Y", "N"],
            ["1", "2", "3", "", "5", "6", "7", "8", "9"],
            "1,2,3,,5,6,7,8,9"
        ],
        // GAME 5
        [
            ["", "4", "2", "8", "3", "6", "1", "5", "9"],
            ["N", "Y", "N", "Y", "N", "N", "N", "N", "N"],
            ["1", "2", "3", "4", "5", "6", "", "8", "9"],
            "1,2,3,4,5,6,,8,9"
        ],
        // GAME 6
        [
            ["8", "7", "6", "4", "2", "1", "", "5", "3"],
            ["N", "N", "N", "Y", "N", "N", "N", "Y", "N"],
            ["1", "2", "3", "4", "5", "6", "7", "8", ""],
            "1,2,3,4,5,6,7,8,"
        ],
];
    
    var the_choice = Math.floor(Math.random() * 6);

    return game_choices[the_choice];
};
